import { useQuery } from "@tanstack/react-query"
import type { QueryFunctionContext } from "@tanstack/react-query"

import type { CustomField, TastyPieListResponse } from "@/types/djangio"

const customFieldKeys = {
    all: [{ _model: "customFields" }] as const,
    byDataType: (quorumDataType: number) => [{ ...customFieldKeys.all[0], quorumDataType }] as const,
}

const fetchCustomFields = ({
    queryKey,
}: QueryFunctionContext<ReturnType<(typeof customFieldKeys)["byDataType"]>>): Promise<
    TastyPieListResponse<CustomField>
> => {
    const [{ quorumDataType }] = queryKey

    const response = DjangIO.app.grassroots.models.CustomTag.objects
        .filter({
            archived: false,
            tag_owner: quorumDataType,
            display_on_create_page: true,
            limit: 0,
            dehydrate_extra: ["group_dict"],
        })
        .GET()

    return response
}

export const useCustomFields = (quorumDataType: number) =>
    useQuery({
        queryKey: customFieldKeys.byDataType(quorumDataType),
        queryFn: fetchCustomFields,
        select: (data) => data.objects,
        // TODO: Do we want to keep the cache time low (or 0), so that the user can see new/updated custom fields?
        // Or do we want to disable it to reduce calls, because Custom Fields aren't changed often anyways?
        // staleTime: Infinity
    })
